<template>
  <div>
    <vxe-card>
      <template #title>
        <vxe-button content="tab.inspectionConfig" mode="text" status="primary"/>
      </template>
      <template #extra>
        <vxe-button content="button.refresh" icon="vxe-icon-refresh" mode="text" status="danger" @click="refresh(warehouse)"/>
        <vxe-button content="button.add" icon="vxe-icon-add" mode="text" status="primary" @click="add"/>
      </template>
      <vxe-table ref="table" :data="list" :loading="loading">
        <vxe-column fixed="left" type="seq" width="40"/>
        <vxe-column :cell-render="{name:'FormatSelect',options:inspectionTypes}" field="inspectionType" title="business.label.inspectionType" width="200"/>
        <vxe-column field="minValue" title="business.label.minValue" width="100"/>
        <vxe-column field="maxValue" title="business.label.maxValue" width="100"/>
        <vxe-column field="sampleValue" title="business.label.sampleValue" width="100"/>
        <vxe-column field="owners" title="business.label.owner">
          <template #default="{ row }">{{getStrings(row.owners, 'name')}}</template>
        </vxe-column>
        <vxe-column field="suppliers" title="business.label.supplier">
          <template #default="{ row }">{{getStrings(row.suppliers, 'name')}}</template>
        </vxe-column>
        <vxe-column field="items" title="business.label.item">
          <template #default="{ row }">{{getStrings(row.items, 'name')}}</template>
        </vxe-column>
        <vxe-column fixed="right" title="business.label.operate" width="auto">
          <vxe-button-group slot-scope="{row}" mode="text">
            <vxe-button content="button.edit" icon="vxe-icon-edit" status="primary" @click.stop="edit(row,false)"/>
            <vxe-button content="button.copy" icon="vxe-icon-copy" status="primary" @click.stop="edit(row,true)"/>
            <vxe-button content="button.delete" icon="vxe-icon-delete" status="danger" @click.stop="remove(row)"/>
          </vxe-button-group>
        </vxe-column>
      </vxe-table>
    </vxe-card>
    <vxe-modal v-model="visible" :loading="loading" :title="$t('tab.inspectionConfig')" type="confirm" width="40%" @confirm="confirm">
      <a-form-model ref="form" :colon="false" :label-col="{span:8}" :model="config" :rules="rules" :wrapper-col="{span:16}">
        <a-row style="margin-left: -4%;margin-right: 4%">
          <a-col span="12">
            <a-form-model-item :label="$t('business.label.inspectionType')" prop="inspectionType">
              <vxe-select v-model="config.inspectionType" :options="inspectionTypes" style="width: 100%"/>
            </a-form-model-item>
          </a-col>
          <a-col span="12">
            <a-form-model-item :label="$t('business.label.minValue')">
              <vxe-number-input v-model="config.minValue" :min="0" style="width: 100%"/>
            </a-form-model-item>
          </a-col>
          <a-col span="12">
            <a-form-model-item :label="$t('business.label.maxValue')">
              <vxe-number-input v-model="config.maxValue" :min="0" style="width: 100%"/>
            </a-form-model-item>
          </a-col>
          <a-col span="12">
            <a-form-model-item :label="$t('business.label.sampleValue')">
              <vxe-number-input v-model="config.sampleValue" :min="0" style="width: 100%"/>
            </a-form-model-item>
          </a-col>
          <a-col span="24">
            <a-form-model-item :label="$t('business.label.owner')" :label-col="{ span: 4 }" :wrapper-col="{ span: 20 }">
              <vxe-textarea :editable="false" :value="getStrings(config.owners,'name')" style="width: 100%" @click="onOwnerSelect"/>
            </a-form-model-item>
          </a-col>
          <a-col span="24">
            <a-form-model-item :label="$t('business.label.supplier')" :label-col="{ span: 4 }" :wrapper-col="{ span: 20 }">
              <vxe-textarea :editable="false" :value="getStrings(config.suppliers,'name')" style="width: 100%" @click="onSupplierSelect"/>
            </a-form-model-item>
          </a-col>
          <a-col span="24">
            <a-form-model-item :label="$t('business.label.item')" :label-col="{ span: 4 }" :wrapper-col="{ span: 20 }">
              <vxe-textarea :editable="false" :value="getStrings(config.items,'name')" style="width: 100%" @click="onItemSelect"/>
            </a-form-model-item>
          </a-col>
        </a-row>
      </a-form-model>
    </vxe-modal>
    <customer-modal ref="ownerModal" selectType="checkbox" title="business.label.owner" @change="onOwnerChange"/>
    <customer-modal ref="supplierModal" selectType="checkbox" title="business.label.supplier" @change="onSupplierChange"/>
    <item-modal ref="itemModal" select-type="checkbox" @change="onItemChange"/>
  </div>
</template>
<script>
import { deleteOne, findAll, findOne, save } from '@/api/Api'
import { Warehouse } from '@/api/dto/common/Warehouse'
import { InspectionConfig } from '@/api/dto/config/InspectionConfig'
import { Party } from '@/api/dto/common/Party'
import { Item } from '@/api/dto/common/Item'
import { getStrings } from '@/utils/util'
import CustomerModal from '@/views/modal/CustomerModal.vue'
import ItemModal from '@/views/modal/ItemModal.vue'

export default {
  name: 'InspectionConfig',
  components: { CustomerModal, ItemModal },
  props: {
    inspectionTypes: { type: Array, default: [] }
  },
  data() {
    return {
      loading: false,
      visible: false,
      warehouse: new Warehouse(),
      list: [],
      config: new InspectionConfig(),
      rules: {
        inspectionType: [{ required: true, message: this.$t('message.canNotBeEmpty') }]
      }
    }
  },
  methods: {
    getStrings,
    onOwnerSelect() {
      this.$refs.ownerModal.open({ available: true, 'type.ordinal': 1 }, this.config, this.config.owners)
    },
    onOwnerChange(value) {
      this.config.owners = value.map(item => {
        return new Party(item)
      })
    },
    onSupplierSelect() {
      this.$refs.supplierModal.open({ available: true, 'type.ordinal': 2, 'owner.ids': this.config.owners.map(item => item.id) }, this.config, this.config.suppliers)
    },
    onSupplierChange(value) {
      this.config.suppliers = value.map(item => {
        return new Party(item)
      })
    },
    onItemSelect() {
      this.$refs.itemModal.open({ available: true, 'owner.ids': this.config.owners.map(item => item.id) }, this.config, this.config.items)
    },
    onItemChange(value) {
      this.config.items = value.map(item => {
        return new Item(item)
      })
    },
    refresh(warehouse) {
      this.warehouse = warehouse
      if (this.warehouse.isNew()) {
        return this.$message.warning('请先选择仓库')
      }
      this.loading = true
      findAll('inspectionConfigFactory', { 'warehouse.id': this.warehouse.id }).then(res => {
        if (res.success) {
          this.list = res.result.map(item => {
            return new InspectionConfig(item)
          })
        }
      }).finally(() => this.loading = false)
    },
    add() {
      this.visible = true
      this.config = new InspectionConfig()
    },
    edit(row, copy) {
      this.visible = true
      this.loading = true
      findOne('inspectionConfigFactory', { id: row.id }).then(res => {
        if (res.success) {
          if (copy) {
            res.result.id = undefined
            res.result.version = undefined
          }
          this.config = new InspectionConfig(res.result)
        }
      }).finally(() => this.loading = false)
    },
    save() {
      this.loading = true
      const config = this.config.toJSONObject()
      config.warehouse = this.warehouse
      save('inspectionConfigPersister', config).then(res => {
        if (res.success) {
          this.config = new InspectionConfig(res.result)
          this.$message.success(this.$t('message.saveSuccess'))
          this.refresh(this.warehouse)
          this.visible = false
        }
      }).finally(() => this.loading = false)
    },
    confirm() {
      this.$refs.form.validate((success) => {
        if (success) this.save()
      })
    },
    remove(row) {
      if (row.id) {
        this.loading = true
        deleteOne('inspectionConfigDeleter', { id: row.id }).then(res => {
          if (res.success) {
            this.refresh(this.warehouse)
            this.$message.success(this.$t('message.deleteSuccess'))
          }
        }).finally(() => this.loading = false)
      } else {
        this.list.splice(this.list.indexOf(row), 1)
      }
    }
  }
}
</script>